document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sms-quiz]').forEach(function (quiz) {
    var resultEl = quiz.querySelector('[data-sms-quiz-result]');
    var buttons = quiz.querySelectorAll('[data-result]');

    var results = {
      'Fredagsmys, tack': 'Du är Fredagsmys-typen 🛋️ — mysig, förutsägbar och alltid redo för en lugn kväll.',
      'Det spårar ur direkt': 'Du är Det Spårade Ur-typen 🌀 — kvällen tar alltid en oväntad vändning med dig.',
      'Lugnt i stugan': 'Du är Lugnt i Stugan-typen 🏡 — ingen fara på taket, du har full koll.'
    };

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-result');
        if (resultEl) {
          resultEl.textContent = results[key] || key;
          resultEl.hidden = false;
        }
      });
    });
  });
});
